import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import PartnersApi from "../../apis/Partners.api";
import partnersApi from "../../apis/Partners.api";
import { setReduxChannel } from "../../redux/store/channel/channelDuck";

import Home from "./Home";
import HomeSquidtv from "./HomeSquidtv";

const Main = (props) => {
	const history = useHistory();
	const dispatch = useDispatch();
	const channelId = props.match.params.id;
	const setChannel = (value) => dispatch(setReduxChannel(value));

	useEffect(() => {
		if (channelId) {
			getInfoDefault();
		}
	}, [props]);

	const getInfoDefault = async () => {
		let param = {
			query: channelId,
			offset: 0,
			pageSize: 3,
		};
		const res = await PartnersApi.getChannel(param);
		if (res.code === 200) {
			const rsq = await partnersApi.getUserInfo({
				userId: res.result?.user_id,
			});
			const rsp = await partnersApi.getMenuChannel({
				influencerId: res.result?.user_id,
			});
			if (rsq.code === 200 && rsp.code === 200) {
				setChannel({
					...res.result,
					name: rsq.result?.name,
					inquiry_link: rsq.result?.inquiry_link,
					youtube_link: rsq.result?.youtube_link,
					instagram_link: rsq.result?.instagram_link,
					ingredient_menu_show: rsp.result?.ingredient_menu_show,
					function_menu_show: rsp.result?.function_menu_show,
					combination_menu_show: rsp.result?.combination_menu_show,
					inquiry_menu_show: rsp.result?.inquiry_menu_show,
					quick_menu_show: rsp.result?.quick_menu_show,
					greetings1: rsp.result?.greetings1,
					greetings2: rsp.result?.greetings2,
					greetings3: rsp.result?.greetings3,
					greetings4: rsp.result?.greetings4,
					email: rsq.result?.user_id,
					placeholder: rsq.result?.placeholder,
				});
			} else {
				setChannel({});
				history.replace("/404");
			}
		} else {
			setChannel({});
			history.replace("/404");
		}
	};

	return (
		<div className="channel-wrap channel-home">
			{/*{channelId === "squidtv8" ? (*/}
			{/*    <HomeSquidtv/>*/}
			{/*) : (*/}
			<Home />
			// )}
		</div>
	);
};
export default Main;
